/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-undef */
/* eslint-disable no-unreachable */
/* eslint-disable react/destructuring-assignment */
import { DeleteOutlined, InfoCircleFilled, PlusOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@apollo/client";
import {
  Image as AntdImage,
  Button,
  Checkbox,
  ColorPicker,
  Drawer,
  Form,
  Input,
  Select,
  Tooltip,
  message,
} from "antd";
import { isEmpty, isString } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { CREATE_WEB_CHAT_WIDGET, UPDATE_WEB_CHAT_WIDGET } from "../../../graphql/mutation";
import { GET_LOCATIONS, GET_TEAM_NAMES } from "../../../graphql/query";
import { s3LogoUploader } from "../../../utils/awslogoUploader";
import UserSelector from "../../commonComponents/userSelector";
import CodeView from "./codeView";
import OriginsJSX from "./originsJsx";

const WidgetForm = props => {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    questions: [""],
    isPhoneRequired: false,
    presetQuestionInd: false,
    switchToSmsInd: false,
    userIds: [],
    indicationMethodCode: "QUESTIONS",
  });
  const uploadRef = useRef(null);
  const [color, setcolor] = useState("#3B82F6");
  const [logo, setlogo] = useState({
    file: null,
    url: "",
    height: 0,
    width: 0,
    isChanged: false,
  });
  const isAdmin = window.location.pathname.includes("admin-dashboard");
  const [origins, setOrigins] = useState([]);
  const [widgetUid, setwidgetUid] = useState("");
  console.log(logo);
  useEffect(() => {
    setFormData({ ...formData, presetQuestionInd: formData.questions.length > 0 });
  }, [formData.questions]);
  useEffect(() => {
    if (props.widgetDrawer.mode === "EDIT") {
      const questions = {};
      const metaData = JSON.parse(props.widgetDrawer.data.metaData);
      (props.widgetDrawer.data.webChatWidgetQuestion || []).forEach((item, index) => {
        questions[`question-${index}`] = item.question;
      });
      setcolor(metaData?.themeColor);
      if (!isEmpty(metaData?.widgetLogo)) {
        const img = new Image();
        img.onload = () => {
          setlogo({
            url: metaData.widgetLogo,
            isChanged: false,
            height: img.height,
            width: img.width,
          });
        };
        img.src = metaData.widgetLogo;
      }
      form.setFieldsValue({
        ...props.widgetDrawer.data,
        ...questions,
        indicationMethodCode: props?.widgetDrawer?.data?.webChatWidgetInitiationMethod?.code,
        ...(!isEmpty(props?.widgetDrawer?.data?.webChatUser[0]?.team)
          ? { teamId: +props?.widgetDrawer?.data?.webChatUser[0]?.team?.id }
          : {
              userIds: (props?.widgetDrawer?.data.webChatUser || []).map(item => +item?.user?.id),
            }),
        metaData,
      });
      //   TODO: Find a way to edit the questions added in the widget configurations
      setFormData({
        ...props?.widgetDrawer?.data,
        questions: (props?.widgetDrawer?.data?.webChatWidgetQuestion || []).map(
          item => item.question
        ),
        indicationMethodCode: props?.widgetDrawer?.data?.webChatWidgetInitiationMethod?.code,
      });
      setOrigins(props?.widgetDrawer?.data?.webChatWidgetOrigin?.map(item => item.origin));
    } else {
      form.setFieldsValue({
        locationId:
          (sessionStorage.getItem("currentLocationId") || "").includes(",") || isAdmin
            ? null
            : +sessionStorage.getItem("currentLocationId"),
      });
    }
  }, [props?.widgetDrawer?.mode, props?.widgetDrawer?.data]);
  const { data: locations, loading: locationsLoader } = useQuery(GET_LOCATIONS, {
    variables: {
      companyId: props?.widgetDrawer?.company?.id,
    },
  });
  const { data: teams, loading: teamsLoader } = useQuery(GET_TEAM_NAMES, {
    variables: {
      companyId: props?.widgetDrawer?.company?.id,
    },
  });
  const close = () => {
    props?.setwidgetDrawer({ ...props?.widgetDrawer, open: false });
  };
  const [createWebChatWidget, { loading: createWebChatWidgetLoader }] =
    useMutation(CREATE_WEB_CHAT_WIDGET);
  const [updateWebChatWidget, { loading: updateWebChatWidgetLoader }] =
    useMutation(UPDATE_WEB_CHAT_WIDGET);
  const handleScrollToTop = () => {
    setTimeout(() => {
      const drawerBody = document.querySelector(".ant-drawer-body");
      if (drawerBody) {
        drawerBody.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 0);
  };
  const handleSave = async value => {
    if (origins.length === 0) {
      return message.error("Please add atleast one origin");
    }
    let widgetLogo = logo.url;
    if (logo.isChanged) {
      // upload the logo to s3
      widgetLogo = await s3LogoUploader(logo.file, process.env.GATSBY_S3_BUCKET);
      if (widgetLogo) {
        setlogo({ ...logo, isChanged: false, url: widgetLogo });
      }
    }
    const payload = {
      ...formData,
      ...value,
      userIds: formData.userIds,
      metaData: {
        ...value.metaData,
        themeColor: color,
        widgetLogo,
      },
    };
    if (props?.widgetDrawer?.mode === "ADD") {
      const res = await createWebChatWidget({
        variables: {
          ...payload,
          companyId: props?.widgetDrawer?.company?.id,
          questions: payload.questions.map(item => item),
          origins,
        },
      });
      if (res.data.createWebChatWidget.statusCode === 200) {
        message.success(res.data.createWebChatWidget.message);
        // props?.widgetDrawer?.openCode(res.data.createWebChatWidget.webChatWidget.widgetUid);
        setwidgetUid(res.data.createWebChatWidget.webChatWidget.widgetUid);
        handleScrollToTop();
        props?.widgetDrawer?.refetch();
      } else {
        message.error(res.data.createWebChatWidget.message);
      }
    } else {
      const res = await updateWebChatWidget({
        variables: { ...payload, origins },
      });
      if (res.data.updateWebChatWidget.statusCode === 200) {
        message.success(res.data.updateWebChatWidget.message);
        // props?.widgetDrawer?.openCode(res.data.updateWebChatWidget.webChatWidget.widgetUid);
        setwidgetUid(res.data.updateWebChatWidget.webChatWidget.widgetUid);
        handleScrollToTop();
        props?.widgetDrawer?.refetch();
      } else {
        message.error(res.data.updateWebChatWidget.message);
      }
    }
  };
  const validateUrl = url => {
    if (isString(url)) {
      console.log(url);
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const isValidUrl = urlRegex.test(url);
      if (isValidUrl) {
        return true;
      }
      message.error("Please enter a valid URL");
      return false;
    }
    message.error("Please enter a valid URL");
    return false;
  };
  const validateFile = file => {
    // Check file size (1MB = 1048576 bytes)
    if (file) {
      console.log(file);
      // 5 mb limit
      if (file.size > 5 * 1024 * 1024) {
        return Promise.reject("Logo size exceeds 5MB limit.");
      }

      // Check image dimensions
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          if (img.height > 50 || img.width > 50) {
            reject("Logo should not be more than 50 pixels");
          } else {
            resolve({ height: img.height, width: img.width });
          }
        };
        img.onerror = () => reject("Invalid image file.");
        console.log(file);
        img.src = URL.createObjectURL(file);
      });
    }
    return Promise.reject("Upload cancelled");
  };

  const handleFileChange = file => {
    const files = [...file];
    console.log(files[0]);
    validateFile(files[0])
      .then(size => {
        console.log("success", size);
        const localUrl = URL.createObjectURL(files[0]);
        console.log(localUrl);
        setlogo({
          url: localUrl,
          file: file[0],
          height: size.height,
          width: size.width,
          isChanged: true,
        });
      })
      .catch(err => {
        console.log(err);
        if (typeof err === "string") {
          message.error(err);
        } else if (err instanceof Error) {
          message.error(err.message);
        } else {
          message.error("An unknown error occurred");
        }
      });
  };
  return (
    <Drawer
      open={props?.widgetDrawer?.open}
      onClose={close}
      title={isEmpty(widgetUid) ? props?.widgetDrawer?.header : "Copy and paste the widget script"}
      width="30%"
      destroyOnClose
      footer={
        <div className="flex-row-centered gap-1">
          {isEmpty(widgetUid) && (
            <Button
              loading={updateWebChatWidgetLoader || createWebChatWidgetLoader}
              key="add"
              type="primary"
              onClick={() => form.submit()}
              className="bg-grey-700"
            >
              Save
            </Button>
          )}
          <Button onClick={close} key="cancel">
            Cancel
          </Button>
        </div>
      }
    >
      {!isEmpty(widgetUid) ? (
        <div className="flex-col-centered w-full items-start gap-1">
          <span className="w-full text-sm text-grey-700">
            Place this code in the section of your webpage where you want the widget to appear
          </span>
          <CodeView onCopy={() => close()} widgetId={widgetUid} />
        </div>
      ) : (
        <Form layout="vertical" form={form} onFinish={handleSave}>
          <Form.Item name="initialText" label="Initial Text">
            <Input placeholder="Enter Intial Text to be displayed to user" name="initialText" />
          </Form.Item>
          {(formData.questions || []).map((item, index) => (
            <QuestionsJSX key={index} index={index} item={item} setFormData={setFormData} />
          ))}
          <div className="flex-row-centered justify-end">
            <Button
              type="primary"
              className="bg-grey-700 flex-row-centered justify-center gap-1"
              onClick={() =>
                setFormData(prev => {
                  const temp = [...prev.questions];
                  temp.push("");
                  return { ...prev, questions: temp };
                })
              }
            >
              <PlusOutlined />
              Add Question
            </Button>
          </div>
          <div className="flex-col-centered w-full gap-1 items-start">
            <span className="flex-row-centered gap-1 items-center xs-600">
              Whitelisted Origins{" "}
              <Tooltip title="This widget will only work in the origins provided here!">
                <InfoCircleFilled />
              </Tooltip>{" "}
            </span>
            <div className="border-brand-500 w-full border-solid border-[2px] rounded-lg p-2 my-1 flex-row-centered flex-wrap">
              <OriginsJSX
                setTags={setOrigins}
                className="flex-wrap gap-1"
                newText="Add Origin"
                tags={origins}
                autoBlur={false}
                validationFn={validateUrl}
              />
            </div>
          </div>
          <Form.Item
            rules={[{ required: true, message: "Please select the Intiation Method" }]}
            name="indicationMethodCode"
            label="Initiation Method"
          >
            <Select
              name="indicationMethodCode"
              options={[
                { label: "Locations", value: "LOCATIONS" },
                { label: "Questions", value: "QUESTIONS" },
              ]}
              value={formData.indicationMethodCode}
              onChange={value => setFormData({ ...formData, indicationMethodCode: value })}
              placeholder="Select the Initiate Method"
            />
          </Form.Item>
          <div className="flex-row-centered gap-1 items-center">
            {formData.indicationMethodCode !== "LOCATIONS" && (
              <Form.Item
                name="locationId"
                label="Location"
                className="w-1/2"
                rules={[
                  {
                    required: formData.indicationMethodCode !== "LOCATIONS",
                    message: "Please select a location",
                  },
                ]}
              >
                <Select
                  placeholder="Select a location"
                  name="locationId"
                  allowClear
                  disabled={props?.widgetDrawer?.mode === "EDIT"}
                  loading={locationsLoader}
                  className="w-full"
                  options={(locations?.getLocations || []).map(item => ({
                    label: item.title,
                    value: +item.id,
                  }))}
                />
              </Form.Item>
            )}
            <UserSelector
              name="userIds"
              required={false}
              handleUsersSelection={values => setFormData({ ...formData, userIds: values })}
              item={{
                name: "Select users",
                item: {
                  user: !isEmpty(
                    props?.data &&
                      props?.data?.webChatUser.length > 0 &&
                      props?.data?.webChatUser[0]?.team
                  )
                    ? []
                    : (props?.data?.webChatUser || []).map(item => item?.user),
                },
              }}
              errorMessage="Please select users"
              validation
              multiple
            />
          </div>
          <Form.Item
            name="teamId"
            label={
              <span className="flex-row-centered gap-1 items-center">
                Select Team
                <Tooltip title="Selecting team will override the users selected">
                  <InfoCircleFilled />
                </Tooltip>
              </span>
            }
            className="w-full"
          >
            <Select
              name="teamId"
              options={(teams?.getTeams?.data || []).map(item => ({
                label: item.name,
                value: +item.id,
              }))}
              loading={teamsLoader}
              allowClear
              placeholder="Select a team"
            />
          </Form.Item>
          <span className="font-bold">Meta Data for chat widget</span>
          <Form.Item name={["metaData", "widgetTitle"]} label="Widget header title">
            <Select
              name={["metaData", "widgetTitle"]}
              placeholder="Select the widget header title configuration"
              options={[
                {
                  label: "Company Name - Location Name",
                  value: "{companyName} - {locationName}",
                },
                {
                  label: "Company Name",
                  value: "{companyName}",
                },
                {
                  label: "Location Name",
                  value: "{locationName}",
                },
              ]}
            />
          </Form.Item>
          <Form.Item name={["metaData", "miniWidgetText"]} label="Widget Caption">
            <Input
              placeholder="Enter Caption that you want to be displayed in minimized widget view"
              name={["metaData", "miniWidgetText"]}
            />
          </Form.Item>
          <Form.Item name={["metaData", "initialTitle"]} label="Welcome popup title">
            <Input placeholder="Enter welcome popup title" name={["metaData", "initialTitle"]} />
          </Form.Item>
          <Form.Item name={["metaData", "initialDescription"]} label="Welcome popup description">
            <Input
              placeholder="Enter welcome popup description"
              name={["metaData", "initialDescription"]}
            />
          </Form.Item>
          <ColorPicker
            value={color}
            onChange={(value, hex) => setcolor(hex)}
            showText={() => <span>Select Theme Color</span>}
          />
          <div className="flex flex-wrap justify-between gap-1">
            <Checkbox
              checked={formData.isPhoneRequired}
              onChange={e => setFormData({ ...formData, isPhoneRequired: e.target.checked })}
            >
              Is Phone Number Required?
            </Checkbox>
            <Checkbox
              checked={formData.presetQuestionInd}
              onChange={e => setFormData({ ...formData, presetQuestionInd: e.target.checked })}
            >
              Show Preset Questions
            </Checkbox>
            <Checkbox
              checked={formData.switchToSmsInd}
              onChange={e => setFormData({ ...formData, switchToSmsInd: e.target.checked })}
            >
              Indicate Switch to SMS
            </Checkbox>
          </div>
          <div className="flex-col-centered gap-1">
            <input
              type="file"
              ref={uploadRef}
              accept="image/*"
              onChange={e => handleFileChange(e.target.files)}
              className="hidden"
            />
            <Button type="primary" className="mt-2" onClick={() => uploadRef.current.click()}>
              Upload Logo
            </Button>
            <div className="px-3 pt-1">
              <ul>
                <li className="text-sm text-grey-500">Maximum file size: 5MB</li>
                <li className="text-sm text-grey-500">Dimensions must not exceed 50x50 pixels</li>
              </ul>
            </div>
            {!isEmpty(logo.url) && (
              <>
                <span>Preview</span>
                <AntdImage width={logo.width} height={logo.height} src={logo.url} />
              </>
            )}
          </div>
        </Form>
      )}
    </Drawer>
  );
};

export default WidgetForm;

function QuestionsJSX({ index, item, setFormData }) {
  return (
    <Form.Item
      label={`Question ${index + 1}`}
      name={`question-${index}`}
      rules={[{ required: true, message: "Please enter the question or remove this question" }]}
      key={index}
    >
      <div className="flex-row-centered gap-2 items-center">
        <Input
          value={item}
          onChange={e =>
            setFormData(prev => {
              const temp = [...prev.questions];
              temp[index] = e.target.value;
              return { ...prev, questions: temp };
            })
          }
          placeholder={`Enter question ${index + 1}`}
          name={`question-${index}`}
        />{" "}
        <DeleteOutlined
          className="cursor-pointer text-red-400"
          onClick={() =>
            // setQuestions(prev => {
            //   const temp = [...prev];
            //   temp.splice(index, 1);
            //   return temp;
            // })
            setFormData(prev => {
              const temp = [...prev.questions];
              temp.splice(index, 1);
              return { ...prev, questions: temp };
            })
          }
        />
      </div>
    </Form.Item>
  );
}
